
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/small-medium-business",
      function () {
        return require("private-next-pages/solutions/small-medium-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/small-medium-business"])
      });
    }
  